var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewscene4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 675,
    viewBox: "0 0 675 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675 0H0V675H675V0Z",
    fill: "#D4D1EB",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 429.6C614.8 423.4 554.5 417.3 515.4 385.3C476.3 353.3 458.3 295.4 416.9 258.1C375.5 220.8 310.6 204 278.1 164.4C245.6 124.8 245.5 62.4 245.4 0H675V429.6Z",
    fill: "#7D65AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 286.4C634.8 282.3 594.7 278.2 568.6 256.8C542.5 235.5 530.6 196.9 502.9 172.1C475.3 147.2 432.1 136 410.4 109.6C388.8 83.2 388.7 41.6 388.6 0H675V286.4Z",
    fill: "#E1685E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 143.2C654.9 141.1 634.8 139.1 621.8 128.4C608.8 117.8 602.8 98.5 589 86C575.2 73.6 553.5 68 542.7 54.8C531.9 41.6 531.8 20.8 531.8 0H675V143.2Z",
    fill: "#FBAE3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 245.4C52.5 272.1 105.1 298.7 142.7 330.4C180.4 362.1 203.3 398.9 248.9 426.1C294.5 453.3 363 470.7 396.9 510.6C430.8 550.5 430.2 612.7 429.6 675H0V245.4Z",
    fill: "#7D65AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 388.6C35 406.4 70 424.1 95.2 445.3C120.3 466.4 135.5 491 165.9 509.1C196.4 527.2 242 538.8 264.6 565.4C287.2 592 286.8 633.5 286.4 675H0V388.6Z",
    fill: "#E1685E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 531.8C17.5 540.7 35 549.6 47.6 560.1C60.1 570.7 67.8 583 83 592C98.2 601.1 121 606.9 132.3 620.2C143.6 633.5 143.4 654.2 143.2 675H0V531.8Z",
    fill: "#FBAE3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 675,
    height: 675,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewscene4);
export default __webpack_public_path__ + "static/media/newscene4.dd9a58a67fcb31b3dd232e8676b0006c.svg";
export { ForwardRef as ReactComponent };